import { render } from "./CareGiverLanding.vue?vue&type=template&id=e2ce7388"
import script from "./CareGiverLanding.vue?vue&type=script&lang=js"
export * from "./CareGiverLanding.vue?vue&type=script&lang=js"

import "./CareGiverLanding.vue?vue&type=style&index=0&id=e2ce7388&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__